export default [
  {
    path: "/categories/list",
    name: "categories-list",
    component: () => import("@/views/pages/category/categories-list/CategoriesList.vue"),
    meta: {
      action: "read",
      resource: "Auth",
    },
  },
  {
    path: "/info",
    name: "info",
    component: () => import("@/views/info/InfoEdit.vue"),
    meta: {
      action: "read",
      resource: "Auth",
    },
  },
  {
    path: "/bookings/list",
    name: "bookings-list",
    component: () => import("@/views/booking/bookings-list/BookingsList.vue"),
    meta: {
      action: "read",
      resource: "Auth",
    },
  },
  {
    path: "/users/list",
    name: "users-list",
    component: () => import("@/views/user/users-list/UsersList.vue"),
    meta: {
      action: "read",
      resource: "users",
    },
  },
  {
    path: "/users/view/:id",
    name: "users-view",
    component: () => import("@/views/user/users-view/UsersView.vue"),
    meta: {
      action: "read",
      resource: "users",
    },
  },
  {
    path: "/users/edit/:id",
    name: "users-edit",
    component: () => import("@/views/user/users-edit/UsersEdit.vue"),
    meta: {
      action: "update",
      resource: "users",
    },
  },
  {
    path: "/users/create",
    name: "users-create",
    component: () => import("@/views/user/users-edit/UsersEdit.vue"),
    meta: {
      action: "create",
      resource: "users",
    },
  },
  {
    path: "/login",
    name: "auth-login",
    component: () => import("@/views/pages/authentication/Login.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: true,
    },
  },
  {
    path: "/banner/list",
    name: "banners-list",
    component: () =>
      import("@/views/pages/banner/banners-list/BannersList.vue"),
    meta: {
      action: "read",
      resource: "Auth",
    },
  },
  {
    path: "/professional/list",
    name: "professionals-list",
    component: () =>
      import(
        "@/views/pages/professional/professionals-list/ProfessionalsList.vue"
      ),
    meta: {
      action: "read",
      resource: "Auth",
    },
  },
  {
    path: "/",
    name: "home",
    component: () =>
      import("@/views/pages/banner/banners-list/BannersList.vue"),
    meta: {
      action: "read",
      resource: "Auth",
    },
  },
  {
    path: "/error-404",
    name: "error-404",
    component: () => import("@/views/error/Error404.vue"),
    meta: {
      layout: "full",
    },
  },
  {
    path: "/pages/not-authorized",
    name: "not-authorized",
    // ! Update import path
    component: () => import("@/views/pages/miscellaneous/NotAuthorized.vue"),
    meta: {
      layout: "full",
      action: "read",
      resource: "Auth",
    },
  },
  {
    path: "*",
    redirect: "error-404",
  },
];
